module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABUAAAAUBAMAAACQZWsAAAAAKlBMVEVHcEw1NTU1NTU4ODg0NDQ1NTU1NTU1NTU4ODg1NTU1NTU1NTU1NTU1NTXCAwbxAAAADnRSTlMA35ggQL9gcxAw8s+vTxes+bsAAACNSURBVAjXY2BABe3aoipQJvuaTJPCYAhb1QBIVE0AMZkUQCSnJIhMhMiCKREGBg4HBgbWBAYGlg1AHADB7AoQmmMBUGsBAwdLQAMDgzCQncDAUxIMZKwAq2GWEUwAqwGpNVzGwMAbADGTGWomQ3YDwi6oG4TBItogtxVOgLhZ6KYtzM0MZqdlVNC8xwAA7SUVs7Wz7ZMAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/downloadicon2.png
// module id = YWFF
// module chunks = 0